export default __webpack_public_path__ + "static/media/10.e340ee3e.pdf";